<template>
  <v-text-field
    label="RFC *"
    dense
    outlined
    :hide-details="!hasError"
    :error="hasError"
    :error-messages="errorMessage"
    :value="value"
    :loading="loading"
    counter
    :maxlength="maxLength"
    @input="handleInput"
  />
</template>

<script>
import _ from 'lodash'
import axios from 'axios'

const PERSONA_FISICA_ID = 'fd457b15-bbf2-4d2f-be75-6cacd26f523a'
//const PERSONA_MORAL_ID  = '1e8548fd-a3d7-47ae-a34d-cba0ecee405c'

export default {
  name: 'RfcTextField',

  props: {
    value: { type: String, default: '' },
    idPersonaTipo: { type: String, default: '' },
    idProveedor: { type: String, default: null }
  },

  data() {
    return {
      hasError: false,
      errorMessage: '',
      loading: false,
      validationSeq: 0 // protege contra race conditions
    }
  },

  computed: {
    maxLength() {
      if (!this.idPersonaTipo) return 13
      return this.idPersonaTipo === PERSONA_FISICA_ID ? 13 : 12
    }
  },

  created() {
    this.debouncedValidate = _.debounce(this.validateRFC, 500)
  },

  methods: {
    normalizeRFC(value) {
      if (!value) return ''
      return String(value)
        .trim()
        .replace(/\s+/g, '')
        .toUpperCase()
    },

    handleInput(rawValue) {
      const value = this.normalizeRFC(rawValue)
      this.$emit('input', value)

      // Aún no se sabe el tipo de persona
      if (!this.idPersonaTipo) {
        this.resetValidation()
        this.debouncedValidate.cancel()
        return
      }

      // Solo validar cuando la longitud es EXACTA
      if (!value || value.length !== this.maxLength) {
        this.resetValidation()
        this.debouncedValidate.cancel()
        return
      }

      this.debouncedValidate(value)
    },

    resetValidation() {
      this.hasError = false
      this.errorMessage = ''
      this.loading = false
    },

    async validateRFC(rfc) {
      const seq = ++this.validationSeq

      try {
        this.loading = true

        const url = `/Proveedores/ValidarRFC/${encodeURIComponent(rfc)}`
        const params = {}

        if (this.idProveedor) {
          params.id_proveedor = this.idProveedor
        }

        const { data } = await axios.get(url, { params })

        // Ignorar respuestas viejas
        if (seq !== this.validationSeq) return

        // Contrato: null = disponible / válido
        if (data == null || data.length == 0) {
          this.hasError = false
          this.errorMessage = ''
        } else {
          console.log(data)

          this.hasError = true
          this.errorMessage = data;
        }
      } catch (err) {
        if (seq !== this.validationSeq) return

        console.error('Error al validar RFC:', err)
        this.hasError = true
        this.errorMessage = 'Error al validar el RFC. Intente nuevamente.'
      } finally {
        if (seq === this.validationSeq) {
          this.loading = false
        }
      }
    }
  },

  beforeDestroy() {
    if (this.debouncedValidate) this.debouncedValidate.cancel()
    this.validationSeq++
  }
}
</script>
